import { IRootState } from "../../../redux/rootReducer";

export const minigridMapState = (state: IRootState) => ({
  minigrid: state.minigrid
});